import { render } from "./New.vue?vue&type=template&id=405ad65c"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/lotties/New.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "405ad65c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('405ad65c', __exports__)) {
    api.reload('405ad65c', __exports__)
  }
  
  module.hot.accept("./New.vue?vue&type=template&id=405ad65c", () => {
    api.rerender('405ad65c', render)
  })

}


export default __exports__